<div class="section-description w-100">
  <ng-content></ng-content>
</div>
